import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import ContractGroupV2PanelPage from "legacy/contract-groups-v2/ContractGroupV2PanelPage"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

// Note: Amplitude is loaded globally

class ContractGroupV2PaymentMethods extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.validator = validatorFactory({
      autoForceUpdate: this,
      messages: { required: "Please select at least one payment method." },
    })
    const form = props.form
    this.state = {
      allowDirectPayment: form.allowDirectPayment,
      acceptedPaymentMethods: this.derivePaymentMethodState(
        form.acceptedPaymentMethods
      ),
      error: false,
    }
    this.next = this.next.bind(this)
  }

  fetchData() {
    return this.stateForUpdate()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.validator.allValid() && prevState.error === false) {
      this.setState({ error: true })
      this.validator.showMessages()
    }

    if (this.validator.allValid() && prevState.error === true) {
      this.setState({ error: false })
      this.validator.hideMessages()
    }

    if (this.state !== prevState) {
      this.props.update(this.stateForUpdate())
    }
  }

  componentWillUnmount() {
    Amplitude.trackEvent("contracts_v2:payment_methods_complete")
    this.props.update(this.stateForUpdate())
  }

  next() {
    this.props.route.goNext()
  }

  stateForUpdate() {
    return {
      allowDirectPayment: this.state.allowDirectPayment,
      acceptedPaymentMethods: this.selectedPaymentMethods(),
    }
  }

  derivePaymentMethodState(acceptedPaymentMethods) {
    return {
      card: acceptedPaymentMethods.includes("card"),
      us_bank_account: acceptedPaymentMethods.includes("us_bank_account"),
    }
  }

  selectedPaymentMethods() {
    return Object.entries(this.state.acceptedPaymentMethods)
      .filter(([_key, value]) => value === true)
      .map(([key, _value]) => key)
  }

  render() {
    return (
      <ContractGroupV2PanelPage
        hasNext={this.props.route.hasNext && !this.state.error}
        hasPrevious={this.props.route.hasPrevious}
        goNext={this.next}
        goPrevious={this.props.route.goPrevious}
        saving={this.props.saving}
      >
        <div className="form-group">
          <label htmlFor="accepted_payment_methods">Payment Methods</label>
          <div className="text-sm text-gray-600">
            Select the payment method(s) your customers can use for this
            contract. At least one must be selected.
          </div>
          <div>
            <FormGroup
              inputType="checkbox"
              name="accepted_payment_methods"
              value={this.state.acceptedPaymentMethods.card}
              onChange={(e) =>
                this.setState({
                  acceptedPaymentMethods: {
                    ...this.state.acceptedPaymentMethods,
                    card: e.target.checked,
                  },
                })
              }
              label="Cards (Credit, Debit, Prepaid)"
            />
            <FormGroup
              inputType="checkbox"
              name="accepted_payment_methods"
              value={this.state.acceptedPaymentMethods.us_bank_account}
              onChange={(e) =>
                this.setState({
                  acceptedPaymentMethods: {
                    ...this.state.acceptedPaymentMethods,
                    us_bank_account: e.target.checked,
                  },
                })
              }
              label="Bank Account/ACH"
              validation={this.validator.message(
                "accepted_payment_methods",
                this.selectedPaymentMethods(),
                "required"
              )}
            />
          </div>
        </div>
        <div className="form-group mt-2">
          <label htmlFor="allow_direct_payment">Other Methods</label>
          <div className="flex space-x-2">
            <FormGroup
              inputType="checkbox"
              name="allow_direct_payment"
              value={this.state.allowDirectPayment}
              onChange={(e) =>
                this.setState({ allowDirectPayment: e.target.checked })
              }
              label="Settle directly with marina (Cash, Check)"
            />
          </div>
        </div>
      </ContractGroupV2PanelPage>
    )
  }
}

ContractGroupV2PaymentMethods.propTypes = {
  form: PropTypes.shape({
    allowDirectPayment: PropTypes.bool,
    acceptedPaymentMethods: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  update: PropTypes.func.isRequired,
  route: PropTypes.shape({
    hasNext: PropTypes.bool,
    hasPrevious: PropTypes.bool,
    goNext: PropTypes.func,
    goPrevious: PropTypes.func,
  }).isRequired,
  saving: PropTypes.bool,
}

export default ContractGroupV2PaymentMethods
